<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :close-on-click="false"
    :nudge-width="options.width"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    origin="center center"
    transition="scale-transition"
  >
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-text-field
              ref="txtComment"
              v-model.trim="form.inputKeyword"
              :rules="[rules.required, rules.limitComment]"
              label="키워드"
              :maxlength="commentLimit"
              :counter="commentLimit"
              required
              autofocus
              @keydown.13.stop="agree"
              @blur="$refs.txtComment.resetValidation()"
            >
              <v-icon slot="prepend">mdi-comment-text-outline</v-icon>
            </v-text-field>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn small text color="primary"
              @click="agree"
            >
              <v-icon small class="mr-2">mdi-content-save</v-icon>저장
            </v-btn>
            <v-btn small text color="error"
              @click="cancel"
            >
              <v-icon small class="mr-2">mdi-cancel</v-icon>취소
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    resolve: null, // 이 방법이 너무 참신하다!
    reject: null,
    options: {
      color: 'primary',
      width: 500
    },
    showMenu: false,
    x: 0,
    y: 0,
    // 구분: 폼
    form: {
      field: '', // 넘어온 필드
      caption: '', // !![2021.4.8 추가] 넘어온 캡션
      keywords: [], // 넘어온 키워드 배열
      inputKeyword: '', // 새로운 키워드
      index: -1, // 수정시 인덱스값
      edit: '' // 수정값
    },
    // 구분: 글자수 제한
    commentLimit: 30
  }),

  computed: {
    // data 에서는 this를 쓸 수 없으므로 computed 에서
    rules () {
      return {
        required: value => !!value || '입력값은 필수입니다',
        limitComment: value => value.length <= this.commentLimit || `글자수는 ${this.commentLimit}자 내외로 해야 합니다`
      }
    }
  },

  watch: {
    'form.inputKeyword': {
      handler: function (val, oldVal) {
        // 한글 글자수 제한을 넘지 못하게 깔끔하게 막는 방법
        if (val.length > this.commentLimit) {
          this.form.inputKeyword = oldVal
          this.$refs.txtComment.lazyValue = oldVal
        }
      }
    }
  },

  methods: {
    dummy () {
      console.log('dummy test')
    },
    sbpop (e) {
      // 서버에서 수신받은 에러는 router 에서 가로채기 하므로 띄우지 않도록 if (!e.response) 를 검사한다.
      if (!e.response) this.$store.commit('SB_POP', { msg: e.message })
    },
    // 초기화
    async init () {
      try {
        this.$refs.txtComment.resetValidation()

        this.form.field = ''
        this.form.caption = '' // !![2021.4.8 추가]
        this.form.keywords = []
        this.form.inputKeyword = ''
        this.form.index = -1
        this.form.edit = ''
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 메뉴 팝업을 띄우는 함수
    async show (evt) {
      try {
        if (!this.showMenu) { // !! 안전장치 - 이미 열려있으면 다시 열리지 않게 한다.
          evt.preventDefault()
          this.showMenu = false
          this.x = evt.clientX
          this.y = evt.clientY

          this.$nextTick(() => {
            this.showMenu = true
          })
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // data setting
    async setData (data) {
      try {
        if (!data) throw new Error(`잘못된 인자 형식입니다.`)

        this.form.inputKeyword = ''

        this.form.field = data.field
        this.form.caption = data.caption // !![2021.4.8 추가]
        this.form.keywords = data.keywords
        this.form.index = data.index
        this.form.edit = data.edit

        // 사용안함: 수정시 - 입력값에 넘어온 값을 매칭한다.
        // if (this.form.index >= 0) {
        //   this.form.inputKeyword = this.form.edit
        // }
        // console.log(this.form)

        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 구분: 키워드 등록 - 수정은 없다
    async agree () {
      try {
        if (!this.$refs.txtComment.validate()) {
          this.$refs.txtComment.focus() // 자연스럽게 보이기 위해 포커싱
          throw new Error(`입력값을 확인하세요.`)
        }

        // !! 중복값 허용안함
        if (this.form.keywords.includes(this.form.inputKeyword)) throw new Error(`이미 등록된 키워드 입니다.`)

        // 전송할 키워드
        let sendKeyword = { field: '', caption: '', keywords: [] }

        // 사용안함:[2021.4.8] 키워드 수정은 없다. 삭제만 있다 해서 새로 작성
        // if (this.form.index >= 0) {
        //   // @: 수정시 - 해당 위치에 새로운 값으로 대체한다.
        //   this.form.keywords.splice(this.form.index, 1, this.form.inputKeyword)
        //   sendKeyword[this.form.field] = this.form.keywords
        // } else {
        //   // @: 등록시 맨 앞에 넣는다.
        //   // 주의: 아래처럼 하면 에러! 버그인듯.. 배열의 length 가 들어간다.
        //   // sendKeyword[this.form.field] = this.form.keywords.unshift(this.form.inputKeyword)

        //   // 귀찮더라도 일단 배열의 맨 앞에 넣고
        //   // this.form.keywords.unshift(this.form.inputKeyword)
        //   // 맨뒤에 넣는것으로 수정
        //   this.form.keywords.push(this.form.inputKeyword)
        //   // 배열을 대입해줘야 한다.
        //   sendKeyword[this.form.field] = this.form.keywords
        // }

        // !![2021.4.8 수정]
        this.form.keywords.push(this.form.inputKeyword) // 입력 키워드를 맨 뒤에 추가한다
        sendKeyword.field = this.form.field
        sendKeyword.caption = this.form.caption
        sendKeyword.keywords = this.form.keywords

        // !! DB 처리(입력/수정)
        const { data } = await this.$axios.post(`lawork/lwc/setKeyword`, sendKeyword)
        if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)

        await this.init()
        this.resolve(true)
        this.showMenu = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    async cancel () {
      try {
        await this.init()
        this.resolve(false) // reject() 가 아니라 resolve(false)로 던져야 한다.
        this.showMenu = false
      } catch (e) {
        this.sbpop(e)
      }
    }
  }
}
</script>
